import defaultStyle from './index.module.scss';
import React, { ReactElement, useEffect, useState } from 'react';
import logoSoyRappi from '../../../assets/logo-soyRappi.png';
import passwordIcon from '../../../assets/icon (2).svg';
import documentIcon from '../../../assets/icon (1).svg';
import Courier from '../../../assets/courier.png';
import Contabilizate from '../../../assets/contabilizate.svg';
import PcIcon from '../../../assets/pcIcon.svg';
import documentUpload from '../../../assets/document.svg';
import Courier1024 from '../../../assets/courier1024.png';
import heroImage from '../../../assets/first-photo.png';
import heroImage375 from '../../../assets/fisrtPhoto375.png';
import heroImage720 from '../../../assets/first-photo-720.png';
import heroImage1024 from '../../../assets/first-photo-1024.png';
import Courier720 from '../../../assets/courier720.png';
import Login from '../../organisms/login';
import { useNavigate } from 'react-router-dom';
import { getFooterText } from '../../../util/stringUtils';
import { WHATSAPP_NUMBER } from '../../../constants/texts';
import { CSD_URL, ELECTRONIC_SIGNATURE_URL } from '../../../constants/links';

const LandingPage = (): ReactElement => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [showLogin, setShowLogin] = useState<boolean>(false);

  const browse = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const onChangeLogin = () => {
    setShowLogin(true);
    browse('/login');
  };

  const goBack = () => {
    setShowLogin(false);
    browse('/');
  };

  let imageSrcCourier;

  if (windowWidth)
    if (windowWidth > 1024) {
      imageSrcCourier = Courier;
    } else if (windowWidth > 720) {
      imageSrcCourier = Courier1024;
    } else if (windowWidth > 375) {
      imageSrcCourier = Courier720;
    }

  let importantMessage;

  if (windowWidth > 1024) {
    importantMessage = (
      <div className={defaultStyle.importantMessage}>
        <div className={defaultStyle.importantSubtitle}>
          Entendiendo que esta documentación es sensible y delicada,
          garantizamos que la misma será tratada de manera responsable, de
          conformidad con lo establecido en el Aviso de Privacidad de SoyRappi.
        </div>
      </div>
    );
  } else if (windowWidth > 720) {
    importantMessage = (
      <div className={defaultStyle.importantMessage}>
        <div className={defaultStyle.importantSubtitle}>
          Entendiendo que esta documentación es sensible y delicada,
          garantizamos que la misma será tratada de manera responsable, de
          conformidad con lo establecido en el Aviso de Privacidad de SoyRappi.
        </div>
      </div>
    );
  } else if (windowWidth > 375) {
    importantMessage = (
      <div className={defaultStyle.importantMessage}>
        <div className={defaultStyle.importantSubtitle}>
          Entendiendo que esta documentación es sensible y delicada,
          garantizamos que la misma será tratada de manera responsable, de
          conformidad con lo establecido en el Aviso de Privacidad de SoyRappi.
        </div>
      </div>
    );
  }

  return (
    <>
      {showLogin ? (
        <Login goBackLanding={goBack} />
      ) : (
        <div className={defaultStyle.container}>
          <div className={defaultStyle.headerContainer}>
            <img
              src={logoSoyRappi}
              alt={'logoSoyRappi'}
              className={defaultStyle.logo}
            />
            <button className={defaultStyle.button} onClick={onChangeLogin}>
              Comenzar registro
            </button>
          </div>
          <div className={defaultStyle.photoContainer}>
            <picture>
              <source media='(max-width: 375px)' srcSet={heroImage375} />
              <source media='(max-width: 720px)' srcSet={heroImage720} />
              <source media='(max-width: 1024px)' srcSet={heroImage1024} />
              <img
                src={heroImage}
                alt={'first-photo'}
                className={defaultStyle.firstPhoto}
                style={{ width: '100%', height: 'auto' }}
              />
            </picture>
            <div className={defaultStyle.contentTittle}>
              <div className={defaultStyle.tittleOne}>Tu facturación</div>
              <div className={defaultStyle.tittleTwo}>en regla</div>
              <p className={defaultStyle.description}>
                Como repartidor en SoyRappi es indispensable que anualmente
                emitas tus facturas. Conoce cómo hacerlo, los documentos
                necesarios y más.
              </p>
            </div>
          </div>
          <div className={defaultStyle.detailsContainer}>
            <div className={defaultStyle.detailsTittle}>
              <div>¿Qué documentos necesito?</div>
            </div>
            <div className={defaultStyle.detailsDescription}>
              <p>
                Para poder registrar tu facturación debes contar con los
                siguientes documentos fiscales, <b>si cuentas solamente con tu
                FIEL, te ayudaremos a conseguir tus sellos: </b>
              </p>
            </div>
            <div className={defaultStyle.documentationContainer}>
              <div>
                <div className={defaultStyle.documentationTittle}>Sellos:</div>
                <div className={defaultStyle.rowDetail}>
                  <img src={passwordIcon} alt={'passwordIcon'} />
                  <div className={defaultStyle.rowDetailText}>
                    Contraseña del certificado CSD
                  </div>
                </div>
                <div className={defaultStyle.rowDetail}>
                  <img src={documentIcon} alt={'documentIcon'} />
                  <div className={defaultStyle.rowDetailText}>
                    Clave del certificado fiel (.key)
                  </div>
                </div>
                <div className={defaultStyle.rowDetail}>
                  <img src={documentIcon} alt={'documentIcon'} />
                  <div className={defaultStyle.rowDetailText}>
                    Certificado CSD (.cer)
                  </div>
                </div>
              </div>
              <div>
                <div className={defaultStyle.documentationTittleFiel}>
                  FIEL:
                </div>
                <div className={defaultStyle.rowDetail}>
                  <img src={passwordIcon} alt={'passwordIcon'} />
                  <div className={defaultStyle.rowDetailText}>
                    Contraseña del certificado de firma electrónica avanzada
                  </div>
                </div>
                <div className={defaultStyle.rowDetail}>
                  <img src={documentIcon} alt={'documentIcon'} />
                  <div className={defaultStyle.rowDetailText}>
                    Clave del certificado CSD (.key)
                  </div>
                </div>
                <div className={defaultStyle.rowDetail}>
                  <img src={documentIcon} alt={'documentIcon'} />
                  <div className={defaultStyle.rowDetailText}>
                    Certificado de firma electrónica avanzada (.cer)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={defaultStyle.instructionsContainer}>
            <img
              src={imageSrcCourier}
              alt={'Courier'}
              className={defaultStyle.courierImage}
            />
            <div className={defaultStyle.instructionsBackground}>
              <div className={defaultStyle.instructionsTittle}>
                Te ayudamos a gestionar tus documentos fiscales
              </div>
              <div className={defaultStyle.instructionsDescription}>
                Para poder emitir facturas debes contar con tus credenciales{' '}
                fiscales obtenidas en el SAT: <b>e.firma (fiel) y CSD.</b> (la
                e.firma y CSD están conformados por 4 archivos y 2 contraseñas
                independientes) <br />
                <br />
                <b>
                  Es necesario tener descargados estos documentos cuando realices tu registro.
                </b>
                <br />
                <br />
                SoyRappi ha puesto a disposición de los Repartidores, asesoría
                gratuita por parte de <b>Contabilízate</b>, para poder gestionar
                los documentos fiscales requeridos.
                <button
                  className={defaultStyle.contabilizateButton}
                  onClick={() =>
                    window.open(
                      'https://grupo.detecno.com/contabilizate-rappi-1/',
                      '_blank'
                    )
                  }
                >
                  <img
                    src={Contabilizate}
                    alt={'Contabilizate'}
                    style={{ marginRight: '12px' }}
                  />
                  Obtener asesoría
                </button>
              </div>
            </div>
          </div>
          <div className={defaultStyle.breakerContainer}>
            <div className={defaultStyle.breakerDescription}>
              Ten en cuenta que si obtuviste tus credenciales fiscales
              recientemente deberás esperar 72 horas a que éstas se validen ante
              el SAT para que puedas realizar tu registro sin problemas.
            </div>
          </div>
          <div className={defaultStyle.documentsContainer}>
            <div className={defaultStyle.documentsTittle}>
              ¿Cómo registro mis documentos con SoyRappi?
            </div>
            <div className={defaultStyle.documentsTitleDescription}>
              Si cuentas sólo con tu FIEL súbela al portal y te ayudaremos a generar
              los Sellos con ayuda de nuestros aliados
            </div>
            <div className={defaultStyle.cardsContainer}>
              <div className={defaultStyle.cardContainer}>
                <img
                  src={PcIcon}
                  alt={'PcIcon'}
                  style={{ marginBottom: '16px' }}
                  className={defaultStyle.pcIcon}
                />
                {windowWidth > 1024 ? (
                  <>
                    <div className={defaultStyle.cardTittle}>
                      Ingresa desde una PC con tu correo o número de telefono
                    </div>

                    <div className={defaultStyle.cardDescription}>
                      Con el boton a continuación podrás empezar el proceso.
                    </div>
                  </>
                ) : (
                  <>
                    <div className={defaultStyle.cardTittle}>
                      Ingresa desde una PC con tu correo o número de telefono
                    </div>

                    <div className={defaultStyle.cardDescription}>
                      Con el boton a continuación podrás empezar el proceso.
                    </div>
                  </>
                )}
              </div>
              <div className={defaultStyle.cardContainer}>
                <img
                  src={documentUpload}
                  alt={'documentUpload'}
                  style={{ marginBottom: '16px' }}
                  className={defaultStyle.documentUpload}
                />
                {windowWidth > 1024 ? (
                  <>
                    <div className={defaultStyle.cardTittle}>
                      Ve a la sección de documentos fiscales
                    </div>

                    <div className={defaultStyle.cardDescription}>
                      Ingresa tu e.firma y CSD y completa la subida de los
                      documentos.
                    </div>
                  </>
                ) : (
                  <>
                    <div className={defaultStyle.cardTittle}>
                      Ve a la sección de documentos fiscales
                    </div>

                    <div className={defaultStyle.cardDescription}>
                      Ingresa tu e.firma y CSD y completa la subida de los
                      documentos.
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className={defaultStyle.registerButtonContainer}>
            <button
              className={defaultStyle.buttonRegister}
              style={{ width: '231px', marginRight: '0' }}
              onClick={onChangeLogin}
            >
              Comenzar registro
            </button>
          </div>
          <div className={defaultStyle.border}></div>
          <div className={defaultStyle.helpInformationContainer}>
            <div className={defaultStyle.informationTittle}>
              Información de ayuda
            </div>
            <div className={defaultStyle.informationSubtitle}>
              Como conseguir una asesoría gratuita con Contabilízate
            </div>
            {windowWidth > 800 ? (
              <div className={defaultStyle.informationDetail}>
                Para recibir atención gratuita de nuestro aliado Contabilízate,
                puedes contactarte acá con su línea de WhatsApp{' '}
                {WHATSAPP_NUMBER} o visita{' '}
                <a
                  href='https://grupo.detecno.com/contabilizate-rappi-1/'
                  target='_blank'
                  className={defaultStyle.urlStyle}
                >
                  {' '}
                  www.contabilizate.com
                </a>
              </div>
            ) : (
              <div className={defaultStyle.informationDetail}>
                Para recibir atención gratuita de nuestro aliado Contabilízate,
                puedes contactarte acá con su línea de WhatsApp{' '}
                {WHATSAPP_NUMBER} o visita
                <a
                  href='https://grupo.detecno.com/contabilizate-rappi-1/'
                  target='_blank'
                  className={defaultStyle.urlStyle}
                >
                  {' '}
                  www.contabilizate.com
                </a>
              </div>
            )}

            <div className={defaultStyle.borderInformation}></div>
            <div className={defaultStyle.informationSubtitle}>
              Links de ayuda
            </div>
            <div className={defaultStyle.informationDetailRow}>
              Tramita tu CSD directamente en{' '}
              <a
                href={CSD_URL}
                target='_blank'
                className={defaultStyle.urlStyle}
              >
                {CSD_URL}
              </a>{' '}
            </div>
            <div className={defaultStyle.informationDetailRow}>
              Tramita tu firma electrónica en{' '}
              <a
                href={ELECTRONIC_SIGNATURE_URL}
                target='_blank'
                className={defaultStyle.urlStyle}
              >
                {ELECTRONIC_SIGNATURE_URL}
              </a>
            </div>
            <div className={defaultStyle.borderInformation}></div>
            <div className={defaultStyle.informationSubtitle}>
              Atención específica a procesos del SAT
            </div>
            {windowWidth > 800 ? (
              <div className={defaultStyle.informationDetail}>
                Para orientación fiscal vía telefónica por parte del SAT da
                click{' '}
                <a
                  href={
                    'https://www.sat.gob.mx/consulta/50308/solicita-orientacion-fiscal-via-telefonica'
                  }
                  target='_blank'
                  className={defaultStyle.urlStyle}
                >
                  aquí
                </a>{' '}
                o llama al 01 (55) 627 22 728{' '}
              </div>
            ) : (
              <div className={defaultStyle.informationDetail}>
                Para orientación fiscal vía telefónica por parte del SAT da
                click{' '}
                <a
                  href={
                    'https://www.sat.gob.mx/consulta/50308/solicita-orientacion-fiscal-via-telefonica'
                  }
                  target='_blank'
                  className={defaultStyle.urlStyle}
                >
                  aquí
                </a>{' '}
                o llama al 01 (55) 627 22 728
              </div>
            )}
            <div className={defaultStyle.borderInformation}></div>
            <div className={defaultStyle.informationSubtitle}>
              Actualización de documentos
            </div>
            {windowWidth > 800 ? (
              <div className={defaultStyle.informationDetail}>
                Si tus sellos o FIEL se encuentran vencidos, los podrás
                actualizar en el siguiente link{' '}
                <a
                  href={'https://satid.sat.gob.mx/'}
                  target={'_blank'}
                  className={defaultStyle.urlStyle}
                >
                  https://satid.sat.gob.mx/
                </a>
              </div>
            ) : (
              <div className={defaultStyle.informationDetail}>
                Si tus sellos o FIEL se encuentran vencidos, los podrás
                actualizar en el siguiente link{' '}
                <a
                  href={'https://satid.sat.gob.mx/'}
                  target={'_blank'}
                  rel='noreferrer'
                  className={defaultStyle.urlStyle}
                >
                  https://satid.sat.gob.mx/
                </a>
              </div>
            )}
            <div className={defaultStyle.borderInformation}></div>
            <div className={defaultStyle.informationSubtitle}>
              ¿Dudas sobre tus declaraciones?
            </div>
            <div className={defaultStyle.informationDetail}>
              Para orientación detallada de declaraciones, dirígete a la
              siguiente web{' '}
              <a
                href={'https://www.heru.app/preguntas-frecuentes'}
                target={'_blank'}
                className={defaultStyle.urlStyle}
              >
                https://www.heru.app/preguntas-frecuentes
              </a>
            </div>
            {importantMessage}
          </div>
          <div className={defaultStyle.border}></div>
          <div className={defaultStyle.footerContainer}>
            <div className={defaultStyle.redirect}>
              <a
                href='https://soyrappi.com.mx/'
                target='_blank'
                className={defaultStyle.urlStyle}
              >
                Ir a Soy Rappi MX
              </a>
            </div>
            <div
              className={defaultStyle.footerText}
              style={{ color: '#868D97' }}
            >
              {getFooterText()}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LandingPage;
